import React from "react";
import { Link } from "react-router-dom";
import { useTheme } from '@mui/material/styles';
import { Typography, Paper, Chip, Stack, Box } from '@mui/material';

function BlogCard({ post }) {
  const theme = useTheme();

  return (
    <Box sx={{ mb: 3 }}>
      <Link 
        to={`/blog/${post.id}`} 
        style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
      >
        <Paper
          elevation={0}
          sx={{
            width: '100%',
            maxWidth: '70vw',
            minHeight: 'auto',
            
            // FIX: Restore your custom card color
            // If 'card' is undefined in your theme, it falls back to 'paper'
            backgroundColor: theme.palette.background.card || theme.palette.background.paper,
            
            padding: 1, 
            borderRadius: 3,
            
            // Add a subtle border to help it pop if the background colors are similar
            border: `1px solid ${theme.palette.divider}`,
            
            // Add the shadow you had previously
            boxShadow: theme.shadows[1], 
            
            transition: 'transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease',
            
            '&:hover': {
               transform: 'translateY(-4px)',
               // Use a stronger shadow on hover
               boxShadow: theme.shadows[4],
               // Highlight the border slightly on hover
               borderColor: theme.palette.text.secondary
            }
          }}
        >
          {/* Date */}
          <Typography variant="caption" sx={{ display: 'block', mb: 1, opacity: 0.7 }}>
            {post.date}
          </Typography>

          {/* Title */}
          <Typography variant="h5" component="h3" sx={{ fontWeight: 'bold', mb: 1.5 }}>
            {post.title}
          </Typography>

          {/* Description */}
          {/* <Typography variant="body1" sx={{ mb: 2, opacity: 0.85 }}>
            {post.description}
          </Typography> */}

          {/* Tags */}
          {post.tags && post.tags.length > 0 && (
            <Stack direction="row" spacing={1} sx={{ mt: 'auto' }}>
              {post.tags.map((tag, index) => (
                <Chip 
                  key={index} 
                  label={tag} 
                  size="small"
                  sx={{ 
                    borderRadius: '6px',
                    // Make chips slightly darker/lighter than the card to stand out
                    backgroundColor: theme.palette.action.hover,
                    cursor: 'pointer',
                    '&:hover': {
                      backgroundColor: theme.palette.action.selected
                    }
                  }} 
                />
              ))}
            </Stack>
          )}
        </Paper>
      </Link>
    </Box>
  );
}

export default BlogCard;